import React, { useEffect, useState, useRef } from "react";
import headerLogo from "../../../assets/v3/images/head-logo.png";
// import headerLogo from '../../../assets/v3/images/logo.svg';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import profile from "../v3/profile.png";

import jwt_decode from "jwt-decode";

import { useContextData } from "../../../core/context/index";
import { getCookie, deleteCookie } from "../../../core/helper/cookie";
import { CgProfile } from "react-icons/cg";
import { MdDashboard } from "react-icons/md";
import { FaBuilding, FaWallet } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { showEmail } from "../../../core/helper/date-format";

import lightSvg from "../../../assets/images/mode-images/light.svg";
import darkSvg from "../../../assets/images/mode-images/dark.svg";

import { ImArrowRight2 } from "react-icons/im";
import {
  BsBank2,
  BsArrowRight,
  BsShield,
  BsCurrencyExchange,
  BsCoin,
  BsCurrencyDollar,
  BsCodeSquare,
} from "react-icons/bs";

import HomeAnnouncement from './HomeAnnouncement'

const NavbarV3 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [profileDropWeb, setProfileDropWeb] = useState(false);
  const [profileDropMob, setProfileDropMob] = useState(false);
  const dropdownRefWeb = useRef(null);
  const dropdownRefMob = useRef(null);
  const [isDropdownActive, setDropdownActive] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleProfileDrop = (to = "web") => {
    if (to == "web") {
      setProfileDropWeb(!profileDropWeb);
    } else {
      setProfileDropMob(!profileDropMob);
    }
  };

  // const handleClickOutside = (event) => {
  //     if(profileDropWeb) {
  //         setProfileDropWeb(false);
  //     } else if(profileDropMob) {
  //         setProfileDropMob(false);
  //     }
  //     if (dropdownRefWeb && dropdownRefWeb.current && !dropdownRefWeb.current.contains(event.target)) {
  //         setProfileDropWeb(false);
  //     }
  //     else if (dropdownRefMob && dropdownRefMob.current && !dropdownRefMob.current.contains(event.target)) {
  //         setProfileDropMob(false);
  //     }
  // };

  // useEffect(() => {
  //     if (profileDropWeb || profileDropMob) {
  //         document.addEventListener("mousedown", handleClickOutside);
  //     } else {
  //         document.removeEventListener("mousedown", handleClickOutside);
  //     }

  //     return () => {
  //         document.removeEventListener("mousedown", handleClickOutside);
  //     };
  // }, [profileDropWeb, profileDropMob]);

  useEffect(() => {
    const selectedTheme = localStorage.getItem("mode") || "light";
    if (selectedTheme === "dark" || selectedTheme === "dark-new") {
      setDarkMode();
      setIsDarkMode(true);
    } else {
      setLightMode();
      setIsDarkMode(false);
    }
  }, []);

  const setDarkMode = () => {
    localStorage.setItem("mode", "dark");
    const mode = "dark-new";
    props.setTheme(mode);
  };

  const setLightMode = () => {
    localStorage.setItem("mode", "light");
    const mode = "light-new";
    props.setTheme(mode);
  };

  const toggleTheme = (e) => {
    if (e.target.checked) {
      setDarkMode();
      setIsDarkMode(true);
    } else {
      setLightMode();
      setIsDarkMode(false);
    }
  };

  const changeTheme = (e) => {
    if (isDarkMode == false) {
      setDarkMode();
      setIsDarkMode(true);
    } else {
      setLightMode();
      setIsDarkMode(false);
    }
  };

  const { myProfile, setUserProfile } = useContextData();
  const [userLogin, setUserLogin] = useState(false);

  const loginChk = async (event) => {
    const token = getCookie("userToken");
    const decodedToken = token ? jwt_decode(token, { header: true }) : {};
    if (decodedToken.typ === "JWT") {
      setUserLogin(true);
    }
  };

  useEffect(() => {
    loginChk();
  }, [myProfile]);

  // useEffect(() => {
  //   $(document).ready(function () {
  //     console.log("navbarOne : props.theme : ", props.theme);
  //     if (props.theme === "dark-new") {
  //       $("body").addClass("light-new");
  //       $("body").removeClass("dark-new");
  //     } else {
  //       $("body").addClass("dark-new");
  //       $("body").removeClass("light-new");
  //     }
  //   });
  // }, []);

  return (
    <>
      {location.pathname === '/' && (
        <HomeAnnouncement />
      )}
      <header className="top-navbar">
        <div className="w-100">
          <div className="tab-hide mobile-hide">
            <div className="d-flex justify-content-between align-items-center">
              <a href="/" className="top-navbar-logo">
                <img src={headerLogo} alt="Header_Logo" />
              </a>
              <div className="top-navbar-link-div">
                <Link
                  to="/markets"
                  className={`top-navbar-link ${
                    location.pathname === "/markets" ? "active" : ""
                  }`}
                >
                  Market
                </Link>
                <span
                  className={`nav-item dropdown nav-item-li top-navbar-link  ${
                    location.pathname &&
                    (location.pathname.split("/spot/")[0] === "" ||
                      location.pathname === "/trade/all-payments")
                      ? "active"
                      : ""
                  }`}
                >
                  <span
                    className="dropdown-toggle"
                    id="dappdrop"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Trade
                  </span>
                  <ul
                    className="dropdown-menu navbar-top-hover-dropdown"
                    aria-labelledby="dappdrop"
                  >
                    <div className="row">
                      <div className="col header-dropdown">
                        <li>
                          <a
                            className="dropdown-item dropdown-item-hover header-dropdown"
                            href="javascript:void(0);"
                            onClick={() => navigate("/spot/BDX_INR")}
                          >
                            <div className="d-flex flex-row align-items-center ">
                              <div className="">
                                <BsCurrencyExchange className="top-nav-dropdown-item-icons-1" />
                              </div>
                              <div className="">
                                <p className="top-nav-dropdown-item-text-1">Spot</p>
                                <p className="top-nav-dropdown-item-text-2">
                                  Spot exchange
                                </p>
                              </div>
                              <div className="ms-auto">
                                {/* <ImArrowRight2 className="top-nav-dropdown-item-icons-2" /> */}
                              </div>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item dropdown-item-hover header-dropdown"
                            href="javascript:void(0);"
                            onClick={() => navigate("/trade/all-payments")}
                          >
                            <div className="d-flex flex-row align-items-center ">
                              <div className="">
                                <BsBank2 className="top-nav-dropdown-item-icons-1" />
                              </div>
                              <div className="">
                                <p className="top-nav-dropdown-item-text-1">P2P</p>
                                <p className="top-nav-dropdown-item-text-2">
                                  Peer-To-Peer Exchange
                                </p>
                              </div>
                              <div className="ms-auto">
                                {/* <ImArrowRight2 className="top-nav-dropdown-item-icons-2" /> */}
                              </div>
                            </div>
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </span>
                {/* <Link to="/spot/BDX_INR" className={`top-navbar-link ${location.pathname === "/spot/BDX_INR" ? "active" : ""}`}>Spot</Link>
                <Link to="/trade/all-payments" className={`top-navbar-link ${location.pathname === "/trade/all-payments" ? "active" : ""}`}>P2P</Link> */}
                <Link
                  to="/staking"
                  className={`top-navbar-link ${
                    location.pathname === "/staking" ? "active" : ""
                  }`}
                >
                  Staking
                </Link>
                <Link
                  to="/fee-structure"
                  className={`top-navbar-link ${
                    location.pathname === "/fee-structure" ? "active" : ""
                  }`}
                >
                  Fees
                </Link>
                <Link
                  to="/faq"
                  className={`top-navbar-link ${
                    location.pathname === "/faq" ? "active" : ""
                  }`}
                >
                  FAQ's
                </Link>
                <Link
                  to="/about"
                  className={`top-navbar-link ${
                    location.pathname === "/about" ? "active" : ""
                  }`}
                >
                  About
                </Link>
              </div>
              <div className="top-navbar-button-div">
                {/* <div className="toggle-switch">
                  <input
                    className="toggle-input"
                    id="toggle"
                    type="checkbox"
                    checked={isDarkMode}
                    onChange={toggleTheme}
                  />
                  <label className="toggle-label" htmlFor="toggle"></label>
                </div> */}
                {userLogin === false ? (
                  <>
                    <button
                      className="register-btn mobile-hide"
                      onClick={() => navigate("/register")}
                    >
                      Register
                    </button>
                    <button className="login-btn" onClick={() => navigate("/login")}>
                      Log in
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="deposit-drop-btn mobile-hide"
                      onClick={() => navigate("/deposit/request/INR")}
                    >
                      Deposit
                    </button>
                    <div className="profile-drop" ref={dropdownRefWeb}>
                      <button
                        className="profile-drop-btn"
                        onClick={() => toggleProfileDrop("web")}
                      >
                        <CgProfile /> <span>Profile</span>
                      </button>
                      {profileDropWeb && (
                        <div className="profile-drop-menu">
                          <div className="profile-drop-menu-head">
                            <img
                              src={profile}
                              className="profile-image"
                              width={40}
                              height={40}
                              alt="Profile_Image"
                            />
                            <div className="profile-drop-menu-head-text">
                              <p className="np-text-1">
                                {myProfile
                                  ? myProfile.email
                                    ? showEmail(myProfile.email)
                                    : myProfile.phoneno
                                  : ""}
                              </p>
                              <span className="ns-text-1">
                                {myProfile
                                  ? myProfile.userType
                                    ? "Regular User"
                                    : "Influencer"
                                  : ""}
                              </span>
                            </div>
                          </div>
                          {/* <div className="m-social-link">
                            <button className="verified-btn">Verified</button>
                            <button className="link-btn">Link X</button>
                          </div> */}
                          <div className="profile-drop-menu-body">
                            <button
                              className="profile-drop-menu-body-btn"
                              onClick={() => {
                                navigate("/my/profile");
                                setProfileDropWeb(false);
                              }}
                            >
                              <MdDashboard />
                              Dashboard
                            </button>
                            <button
                              className="profile-drop-menu-body-btn"
                              onClick={() => {
                                navigate("/my/wallet");
                                setProfileDropWeb(false);
                              }}
                            >
                              <FaWallet />
                              Assets
                            </button>
                            <button
                              className="profile-drop-menu-body-btn"
                              onClick={() => {
                                navigate("/my/wallet/history");
                                setProfileDropWeb(false);
                              }}
                            >
                              <FaBuilding />
                              Orders
                            </button>
                          </div>
                          <div className="profile-drop-menu-foot">
                            <button
                              className="profile-drop-menu-body-btn"
                              onClick={() => {
                                deleteCookie("userToken");
                                setUserProfile();
                                // navigate("/login");
                                window.location.reload();
                              }}
                            >
                              <FiLogOut />
                              Log out
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div>
                  <span className="item">
                    <img
                      src={props.theme == "light-new" ? lightSvg : darkSvg}
                      alt="theme"
                      onClick={() => {
                        changeTheme();
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="desktop-hide">
            <div className="mobile-route-dropdown">
              <div>
                <a href="/" className="top-navbar-logo">
                  <img src={headerLogo} alt="Header_Logo" />
                </a>
              </div>
              <div className="d-flex align-items-center">
                <div className="top-navbar-button-div">
                  {/* <div className="toggle-switch-res">
                    <input
                      className="toggle-input"
                      id="toggle"
                      type="checkbox"
                      checked={isDarkMode}
                      onChange={toggleTheme}
                    />
                    <label className="toggle-label-res" htmlFor="toggle"></label>
                  </div> */}
                  {userLogin === false ? (
                    <>
                      <button
                        className="register-btn-res mobile-hide"
                        onClick={() => navigate("/register")}
                      >
                        Register
                      </button>
                      <button
                        className="login-btn-res"
                        onClick={() => navigate("/login")}
                      >
                        Log in
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="register-btn mobile-hide"
                        onClick={() => navigate("/deposit/request/INR")}
                      >
                        Deposit
                      </button>
                      <div className="profile-drop" ref={dropdownRefMob}>
                        <button
                          className="profile-drop-btn-res"
                          onClick={() => toggleProfileDrop("mob")}
                        >
                          <CgProfile />
                        </button>
                        {profileDropMob && (
                          <div className="profile-drop-menu-res">
                            <div className="profile-drop-menu-head">
                              <img
                                src={profile}
                                className="profile-image"
                                width={40}
                                height={40}
                                alt="Profile_Image"
                              />
                              <div className="profile-drop-menu-head-text">
                                <p className="np-text-1">
                                  {myProfile
                                    ? myProfile.email
                                      ? showEmail(myProfile.email)
                                      : myProfile.phoneno
                                    : ""}
                                </p>
                                <span className="ns-text-1">
                                  {myProfile
                                    ? myProfile.userType
                                      ? "Regular User"
                                      : "Influencer"
                                    : ""}
                                </span>
                              </div>
                            </div>
                            {/* <div className="m-social-link">
                              <button className="verified-btn">Verified</button>
                              <button className="link-btn">Link X</button>
                            </div> */}
                            <div className="profile-drop-menu-body">
                              <button
                                className="profile-drop-menu-body-btn"
                                onClick={() => {
                                  navigate("/my/profile");
                                  setProfileDropMob(false);
                                }}
                              >
                                <MdDashboard />
                                Dashboard
                              </button>
                              <button
                                className="profile-drop-menu-body-btn"
                                onClick={() => {
                                  navigate("/my/wallet");
                                  setProfileDropMob(false);
                                }}
                              >
                                <FaWallet />
                                Assets
                              </button>
                              <button
                                className="profile-drop-menu-body-btn"
                                onClick={() => {
                                  navigate("/my/wallet/history");
                                  setProfileDropMob(false);
                                }}
                              >
                                <FaBuilding />
                                Orders
                              </button>
                            </div>
                            <div className="profile-drop-menu-foot">
                              <button
                                className="profile-drop-menu-body-btn"
                                onClick={() => {
                                  deleteCookie("userToken");
                                  setUserProfile();
                                  // navigate("/login");
                                  window.location.reload();
                                }}
                              >
                                <FiLogOut />
                                Log out
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <div>
                    <span className="item">
                      <img
                        src={props.theme == "light-new" ? lightSvg : darkSvg}
                        alt="theme"
                        onClick={() => {
                          changeTheme();
                        }}
                      />
                    </span>
                  </div>
                </div>
                <button
                  className="mobile-route-dropdown-btn"
                  onClick={() => toggleMenu()}
                >
                  <IoMenu />
                </button>
              </div>

              <div className={`mobile-route-dropdown-menu ${
                  isMenuOpen ? "open" : ""
                }`}
              >
                <div className="menu-content">
                  <div className="menu-content-head">
                    <button className="close-btn" onClick={() => toggleMenu()}>
                      <IoClose fontSize={20} />
                    </button>
                  </div>
                  <Link
                    to="/markets"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/markets" ? "active" : ""
                    }`}
                  >
                    Market
                  </Link>
                  <Link
                    to="/spot/BDX_INR"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/spot/BDX_INR" ? "active" : ""
                    }`}
                  >
                    Spot
                  </Link>
                  <Link
                    to="/trade/all-payments"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/trade/all-payments" ? "active" : ""
                    }`}
                  >
                    P2P
                  </Link>
                  <Link
                    to="/staking"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/staking" ? "active" : ""
                    }`}
                  >
                    Staking
                  </Link>
                  <Link
                    to="/fee-structure"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/fee-structure" ? "active" : ""
                    }`}
                  >
                    Fees
                  </Link>
                  <Link
                    to="/faq"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/faq" ? "active" : ""
                    }`}
                  >
                    FAQ's
                  </Link>
                  <Link
                    to="/about"
                    onClick={toggleMenu}
                    className={`menu-link ${
                      location.pathname === "/about" ? "active" : ""
                    }`}
                  >
                    About
                  </Link>
                  {/* {userLogin === false ? (
                      <div className='tab-hide mobile-hide'>
                        <button className='login-btn' onClick={() => navigate("/login")}>Log in</button>
                      </div>
                    ) :
                    <>
                    <button className='login-btn' onClick={() => navigate("/my/profile")}>Dashboard</button>
                    <button className='login-btn' onClick={() => {
                      deleteCookie("userToken");
                      setUserProfile();
                      // navigate("/login");
                      window.location.reload();
                    }}>Log Out</button>
                    </>
                  } */}
                  {/* <div className="toggle-switch">
                    <input
                      className="toggle-input"
                      id="toggle"
                      type="checkbox"
                      checked={isDarkMode}
                      onChange={toggleTheme}
                    />
                    <label className="toggle-label" htmlFor="toggle"></label>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

      </header>
    </>
  );
};

export default NavbarV3;
